import { useCallback, useMemo, useState } from "react";
import { AppState } from "../../../redux/store";
import { useSelector } from "react-redux";
import ProfilePic from "../../ProfilePic";
import { NavigationId } from "../../../navigation/AppParamList";
import { useLocation, useNavigate } from "react-router-dom";
import { DarkTheme, useTheme } from "../../../hooks/useTheme";
import { m } from "framer-motion";
import { Colors } from "../../../utils/colors";
import { OnboardingFlowType, ThemeType } from "@markit/common.types";
import TeamMemberRoleBanner from "../TeamMembers/TeamMemberRoleBanner";
import { Icon } from "@iconify/react";
import OnboardingFlowDot from "../../Onboarding/OnboardingFlowDot";

type CreatorModeSidebarProfileProps = {
  eventTheme?: ThemeType;
};

const CreatorModeSidebarProfile = (props: CreatorModeSidebarProfileProps) => {
  const { eventTheme } = props;
  const accountData = useSelector(
    (state: AppState) => state.account.accountData
  );
  const pathname = useLocation().pathname;
  const { theme } = useTheme(eventTheme);
  const isDarkTheme = useMemo(() => theme && theme === DarkTheme, [theme]);
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  const isSelected = useMemo(
    () => pathname === NavigationId.HOME_PROFILE,
    [pathname]
  );

  const viewProfile = useCallback(() => {
    navigate(NavigationId.HOME_PROFILE);
  }, [navigate]);

  return (
    <div className="ColumnNormal" style={{ paddingInline: 10 }}>
      <TeamMemberRoleBanner containerStyles={{ marginTop: 10 }} />
      <m.div
        className="AlignedRowSelect"
        style={{
          gap: 7,
          marginBlock: 10,
          paddingBlock: 10,
          paddingInline: 7,
          borderRadius: 8,
          backgroundColor:
            isSelected || isHovered
              ? isDarkTheme
                ? Colors.GRAY7
                : Colors.GRAY6
              : isDarkTheme
                ? Colors.GRAY10
                : Colors.WHITE,
        }}
        onHoverStart={() => setIsHovered(true)}
        onHoverEnd={() => setIsHovered(false)}
        transition={{ duration: 0.1 }}
        onClick={viewProfile}
      >
        <div>
          <ProfilePic
            user={accountData}
            size={40}
            forcePointer
            blueGradientBackground
          />
        </div>
        <div className="AlignedRow" style={{ gap: 7 }}>
          <div className="ColumnNormalSelect" style={{ gap: 5, maxWidth: 120 }}>
            <span className="bodyMedium TwoLineText" style={theme.PrimaryText}>
              {accountData.fullName || "No Name"}
            </span>
            <div className="AlignedRow" style={{ gap: 2 }}>
              <span className="smallBodySubtext">Link in Bio</span>
              <Icon
                icon="ion:chevron-forward"
                height={12}
                style={{ color: Colors.GRAY1, marginBottom: -1 }}
              />
            </div>
          </div>
          {!accountData.profilePicURL ? (
            <OnboardingFlowDot flowTypes={[OnboardingFlowType.PROFILE_PIC]} />
          ) : null}
        </div>
      </m.div>
    </div>
  );
};

export default CreatorModeSidebarProfile;
